import { render } from "./ChipSvg.vue?vue&type=template&id=31d22098"
import script from "./ChipSvg.vue?vue&type=script&lang=js"
export * from "./ChipSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__